import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import { store } from './store'
import VueAnalytics from 'vue-analytics'

const fb = require('./firebaseConfig.js')
import './registerServiceWorker'

import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

Vue.config.productionTip = false

Vue.use(VueAnalytics, {
    id: 'UA-136353937-1',
    router
})

// handle page reloads
let app
fb.auth.onAuthStateChanged(user => {
    if (!app) {
        app = new Vue({
            el: '#app',
            router,
            store,
            render: h => h(App)
        })
    }
})


// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app')





